import { Tooltip } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';

import LoaderComponent from '@components/LoaderComponent';
import SetStyleSubCategory from '@components/SetStyleSubCategory';
import { toastError } from '@components/Toast';

import useClickOutside from '@hooks/useClickOutside';

import { fetchProductInfo } from '@store/actions/DesignToolAction';

import ApiClient from '@lib/apiClient';

import {
	addImageSuffix,
	changeDateFormat,
	onErrorImageLoad,
	renderSetImages,
	showDesignViewPage
} from '@utils/Util';

const DesignSelectionModal = ({ closeModal, productId, setProduct, setConvertedImage, requestFrom }) => {
	const [loader, setLoader] = useState(true);
	const [collectionData, setCollectionData] = useState([]);
	const designToolStore = useSelector((store) => store.designToolStore);
	const { id } = useParams();
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const popUpRef = useRef(null);

	const onOutSideClick = () => {
		closeModal();
	};
	useClickOutside(popUpRef, onOutSideClick);

	useEffect(() => {
		let designId = productId ? productId : id;
		ApiClient.GET('fetchCollectionByProduct', designId)
			.then((response) => {
				setCollectionData(response.data);
				setLoader(false);
			})
			.catch((error) => {
				toastError(error.response.data.message);
				setLoader(false);
			});
	}, []);

	const fetchProductInfoById = (item) => {
		dispatch(fetchProductInfo(item.id));
		if (setProduct && showDesignViewPage(item)) {
			setProduct(item);
		} else {
			let activeTabName = new URLSearchParams(location.search).get('activeTab');
			localStorage.setItem('fromRoute', location.pathname);
			navigate(`/designs/edit/${item.id}?activeTab=${!activeTabName ? 'design' : activeTabName}`);
		}
		setConvertedImage && setConvertedImage(null);
		closeModal();
	};

	const renderColorList = () => {
		return designToolStore?.colors?.map((item, index) => {
			if (item?.compositeColorList) {
				return (
					<div key={`multi_colors_${index}`} className="multicolors">
						{renderMultiColor(item)}
					</div>
				);
			} else {
				return (
					<div key={`solid_colors_${index}`} className="solid-colors d-flex">
						{renderSolidColor(item, index)}
					</div>
				);
			}
		});
	};

	const renderMultiColor = (item) => {
		return item.compositeColorList.map((color, index) => {
			return (
				<Tooltip title={color?.name} placement="top" arrow key={`multicolor_${index}`}>
					<span className="color-icon" style={{ background: color.hexCode }} />
				</Tooltip>
			);
		});
	};

	const renderSolidColor = (item, index) => {
		return (
			<div className="sinlge-group" key={`solidColor_${index}`}>
				<Tooltip title={item?.name} placement="top" arrow>
					<span className="color-icon" style={{ background: item.hexCode }} />
				</Tooltip>
			</div>
		);
	};

	const getSetDesignDocuments = (memberList) => {
		let designDocuments = [];
		memberList.forEach((member) => {
			designDocuments = [...designDocuments, ...member.designDocuments];
		});
		return designDocuments;
	};

	const renderAllProducts = () => {
		return collectionData?.productResponseList?.map((item, index) => {
			let selected = parseInt(id) === parseInt(item.id) || parseInt(productId) === parseInt(item.id);
			return (
				<span key={`design_thumbnail_${index}`} className={selected ? 'selected' : ''}>
					{!item.isSet && (
						<Tooltip title={item.name + ' ' + item.referenceNumber} placement={'top'} arrow>
							<img
								onClick={() => fetchProductInfoById(item)}
								src={addImageSuffix(item?.designDocuments[0]?.docUrl, '')}
								onError={(e) =>
									onErrorImageLoad(e, item?.designDocuments[0]?.docUrl, 'product')
								}
								alt="design-thumbnail"
							/>
						</Tooltip>
					)}
					{item?.isSet && (
						<Tooltip title={item.name + ' ' + item.referenceNumber} placement={'top'} arrow>
							{renderSetImages(getSetDesignDocuments(item?.setMemberProducts || []), '', () =>
								setProduct(item)
							)}
						</Tooltip>
					)}
				</span>
			);
		});
	};

	return (
		<LoaderComponent loading={loader}>
			<div
				className={`${
					requestFrom === 'TECHPACK_VIEW'
						? 'design-view-edit-modal teckpack-design-view-edit-modal'
						: 'design-view-edit-modal'
				}`}
				ref={popUpRef}
			>
				<div className="design-view-container">
					<div className="left-side">
						<p className="regular-14 gray_dark_01">{designToolStore?.availabilityStatus}</p>
						<div className="selected-design-iamge">
							{!designToolStore?.isSet && (
								<img
									src={addImageSuffix(designToolStore?.designDocuments?.[0]?.docUrl, '')}
									onError={(e) =>
										onErrorImageLoad(
											e,
											designToolStore?.designDocuments?.[0]?.docUrl,
											'product'
										)
									}
									alt="design-image"
								/>
							)}
							{designToolStore?.isSet &&
								renderSetImages(
									getSetDesignDocuments(designToolStore?.setMemberProducts || [])
								)}
						</div>
						<div className="design-details-info">
							<h3 className="regular-14 gray_dark_01 weight-500">
								{designToolStore?.referenceNumber}
							</h3>
							<ul className="common-list-component">
								{!designToolStore?.isSet && <li>{designToolStore?.productGroup}</li>}
								{designToolStore?.isSet && (
									<li>{designToolStore?.setMemberProducts?.[0]?.productGroup}</li>
								)}
								{!designToolStore?.isSet && <li>{designToolStore?.subCategory}</li>}
								{designToolStore?.isSet && <SetStyleSubCategory product={designToolStore} />}
								<li>
									{changeDateFormat(designToolStore?.addedAt, 'YYYY-MM-DD', 'DD MMM, YYYY')}
								</li>
							</ul>
							<div className="colors-row d-flex align-items-center">
								{renderColorList()}

								<span className="pt-1">{designToolStore?.addedByName}</span>
							</div>
						</div>
					</div>
					<div className="right-side">
						<div className="d-flex justify-content-between">
							{location.pathname === '/collections/view/' + collectionData?.collectionId && (
								<p
									className="regular-14 gray_dark_01 c-name d-flex align-items-center"
									onClick={() => closeModal()}
								>
									<span className="mr-1">{collectionData?.collectionName}</span>
									<img
										src={`${process.env.PUBLIC_URL}/icons/external-link.svg`}
										alt="external link"
									/>
								</p>
							)}
							{location.pathname !== '/collections/view/' + collectionData?.collectionId && (
								<Link to={'/collections/view/' + collectionData?.collectionId}>
									<p className="regular-14 gray_dark_01 c-name d-flex align-items-center">
										<span className="mr-1">{collectionData?.collectionName}</span>
										<img
											src={`${process.env.PUBLIC_URL}/icons/external-link.svg`}
											alt="external link"
										/>
									</p>
								</Link>
							)}
							<span className="cursor-pointer" onClick={() => closeModal()}>
								<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
							</span>
						</div>
						<div className="all-designs-grid-container scroll-y-label">{renderAllProducts()}</div>
					</div>
				</div>
			</div>
		</LoaderComponent>
	);
};

export default DesignSelectionModal;
